import React from "react";
import { inputBaseClasses, Stack } from "@mui/material";
import Field from "@hyro-components/fields/HyroField";
import { FIELD_TYPES } from "@hyro-components/fields/utils";
import FilterFieldHeader from "../filter-field-header/FilterFieldHeader";
import { FILTER_OPERATORS_DATA } from "../../HyroFilter.consts";

const FilterFieldText = ({ label, value, onChange, onClose, operator = FILTER_OPERATORS_DATA.CONTAINS.key }) => {
  const handleValueChange = (e) => {
    const val = typeof e === "string" ? e : e?.target?.value;
    onChange({ value: val ? [val] : [], operator });
  };

  return (
    <Stack gap={1} padding={1.5}>
      <FilterFieldHeader label={label} operator={operator} onChange={newOperator => onChange({ operator: newOperator, value })} />

      <Field
        fieldType={FIELD_TYPES.TEXT}
        showCopyButton={false}
        autoFocus
        value={value?.[0] || ""}
        sx={{
          height: "44px",
          [`& .${inputBaseClasses.root}`]: {
            height: "44px",
            paddingBlock: "0"
          }
        }}
        onChange={handleValueChange}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onClose();
          }
        }}
      />
    </Stack>
  );
};

export default FilterFieldText;
